import { gql } from "@apollo/client";

export const READ_NOTIFICATION = gql`
mutation readNotificationUpdate($customerId:ID!){
    readNotificationUpdate(customerId:$customerId)
  }`